export function IconList({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="12"
      fill="none"
    >
      <path
        fill="currentColor"
        d="M2.12 0H.514l.605 2H2.75L2.12 0Zm11.612 0H3.127l.605 2 10.754-.404L13.732 0ZM2.119 5H.515l.605 2H2.75L2.12 5Zm11.613 0H3.127l.605 2 10.754-.404L13.732 5ZM.515 10h1.604l.632 2H1.12l-.605-2Zm2.612 0h10.605l.754 1.596L3.732 12l-.605-2Z"
      />
    </svg>
  );
}
